import React, { useState, useEffect } from 'react';
import {
  collection,
  onSnapshot,
} from "firebase/firestore";
import { db } from '../../../firebase';
import EmptyList from '../components/common/EmptyList';
import BlogList from '../components/Home/BlogList';
import Header from '../components/Home/Header';
import { blogList } from '../../../config/data';
import Navbar from '../../main/Navbar2';

const Home = () => {
  const [blogs, setBlogs] = useState(blogList);
  const [data, setData] = useState([]);
  
  useEffect(() => {
    
    // LISTEN (REALTIME)
    const unsub = onSnapshot(
      collection(db, "posts"),
      (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });
        setData(list);
      },
      (error) => {
        console.log(error);
      }
    );

    return () => {
      unsub();
    };
  }, []);

  return (
    <div>
      {/* Page Header */}
      <Navbar/>
      <Header />

      {/* Blog List & Empty View */}
      <div className="p-4">
      {!data.length ? <EmptyList /> : <BlogList blogs={Array.from(data)} />}
      </div>
    </div>
  );
};

export default Home;
